import { ParkingCounter } from '@/common/parkingTypes';
import parkingRestRepository from './restApi/parkingRestRepository';

export interface ParkingRepository {
  getStats(): Promise<ParkingCounter[]>;
  updateInsideCount(id: number, inside: number): Promise<void>;
  updateTotalCount(id: number, total: number): Promise<void>;
}

const parkingRepository: ParkingRepository = parkingRestRepository;
export default parkingRepository;
